/*
 * hp-shoppable-image -- opens a hotspot's product card on TAP.
 *
 * Hover and keyboard focus are pure CSS (sections/hp-shoppable-image.liquid,
 * `:hover` / `:focus-within`); this adds the case neither covers, a touch
 * screen. A marker toggles `is-open` on its spot, one spot at a time; a tap
 * outside or Escape closes it. `aria-expanded` follows the open state.
 *
 * Fails safe: without it, a card still opens on hover and on focus, and the
 * card is an ordinary link.
 */
(() => {
  if (customElements.get('hp-shoppable-image')) return;

  class HpShoppableImage extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const marker = event.target.closest('.hp-shop-img__marker');
        if (!marker || !this.contains(marker)) return;
        const spot = marker.closest('.hp-shop-img__spot');
        this.setOpen(spot.classList.contains('is-open') ? null : spot);
      };
      this.onOutside = (event) => {
        if (this.open && !this.open.contains(event.target)) this.setOpen(null);
      };
      this.onKey = (event) => {
        if (event.key !== 'Escape' || !this.open) return;
        const marker = this.open.querySelector('.hp-shop-img__marker');
        this.setOpen(null);
        if (marker) marker.focus();
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('pointerdown', this.onOutside);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('pointerdown', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }

    setOpen(spot) {
      if (this.open && this.open !== spot) {
        this.open.classList.remove('is-open');
        this.open.querySelector('.hp-shop-img__marker')?.setAttribute('aria-expanded', 'false');
      }
      this.open = spot;
      if (spot) {
        spot.classList.add('is-open');
        spot.querySelector('.hp-shop-img__marker')?.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('hp-shoppable-image', HpShoppableImage);
})();
